import React from 'react';
import './SobrePlataforma.scss';
import Ilustracao from '../../../assets/images/planos/pcs.png'



const SobrePlataforma = () => {

    return (
        <>
            <div className="view-sobre-plataforma">

                <div className="titulo">
                    PLATAFORMA DESENVOLVIDA <br /> EXCLUSIVAMENTE PARA <br /> INTEGRADORES <br /> DE ENERGIA SOLAR
                </div>
               {/*  <div className="icones">
                    Icones Web, Mobile e Desktop
                </div> */}
                <div className="ilustracao">
                    <img src={Ilustracao} alt="Ilustracao" />
                </div>

            </div>
        </>

    )
}

export default SobrePlataforma;